<template>
	<div
		class="modal fade"
		id="maintenance-modal"
	>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header px-5 py-4 mb-3">
					<h4 class="text-6xl m-0 text-center">MANUTENÇÃO!</h4>
					<button
						type="button"
						class="position-absolute btn btn-light p-3 ps-r-0 ps-t-0 m-3"
						@click="CloseModal"
					>
						<i class="far fa-times mx-1"></i>
					</button>
				</div>
				<div class="modal-body my-5">
					<p class="mb-0 text-3xl text-center">
						O SERVIDOR ENTRARÁ EM MANUTENÇÃO DIA
						<span class="highlight">14/05/2026</span> ÀS
						<span class="highlight">00:45H</span>. DURANTE A
						MANUTENÇÃO, PODE SER QUE OS SERVIÇOS FIQUEM
						INDISPONÍVEIS.
					</p>
					<br />
					<p class="mb-0 text-3xl text-center">
						A PREVISÃO PARA A VOLTA DOS SERVIÇOS É
						<span class="highlight">14/05/2026</span> ÀS
						<span class="highlight">01:20H</span>, PORÉM AINDA PODEM
						HAVER INSTABILIDADES.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Maintenance',
		methods: {
			CloseModal() {
				localStorage.setItem('readMaintenanceNotificationV2', 'true')
				window.jQuery('#maintenance-modal').modal('hide')
			},
		},
		async mounted() {
			const readMaintenanceNotification = localStorage.getItem(
				'readMaintenanceNotificationV2'
			)
			const hasPassedMaintenanceTime =
				new Date() > new Date('2026-05-14T01:20:00')
			if (!readMaintenanceNotification && !hasPassedMaintenanceTime) {
				window.jQuery('#maintenance-modal').modal('show')
			}

			// Remove V1
			localStorage.removeItem('readMaintenanceNotification')
		},
	}
</script>

<style lang="scss" scoped>
	#maintenance-modal {
		.modal-dialog {
			max-width: 100vw;
			margin: unset;

			.modal-content {
				height: 100vh;

				.modal-body {
					padding: 2rem;

					.highlight {
						font-weight: bold;
						color: var(--fontColor);
					}
				}
			}
		}
	}
</style>
